@if (device.isMobile && !device.isTablet) {
    <ms-skeleton-main-mobile [pageName]="pageName" />
}
@if (!device.isMobile || device.isTablet) {
    <ms-skeleton-main-desktop [pageName]="pageName" />
}
